export default __webpack_public_path__ + "static/media/new-kingdom-points-tutorial-1x.221ee4e5.webp";